const META_HOTEL_USER_SOURCE = 'meta hotel';

// The source is read from the URL and never from the affiliate cookie, whose
// long expiration would keep matching stale visits.
export function isMetaHotelUser(): boolean {
  const userSource = new URL(window.location.href).searchParams.get(
    'utm_medium'
  );

  return userSource?.toLowerCase() === META_HOTEL_USER_SOURCE;
}
